/**
 * Global JavaScript for Nakhrili Shopify Theme
 * Plain vanilla JS, no jQuery.
 */

document.addEventListener('DOMContentLoaded', () => {
  // ── Gallery: Thumbnail strip + Prev/Next arrows ──────────────────────────
  const mainImage   = document.getElementById('main-product-image');
  const thumbBtns   = document.querySelectorAll('.thumb-btn');
  const prevBtn     = document.getElementById('gallery-prev');
  const nextBtn     = document.getElementById('gallery-next');
  let currentIndex  = 0;

  function setActiveThumb(index) {
    thumbBtns.forEach((t, i) => {
      t.classList.toggle('border-primary', i === index);
      t.classList.toggle('border-transparent', i !== index);
    });
    currentIndex = index;
  }

  thumbBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const src   = btn.getAttribute('data-src');
      const index = parseInt(btn.getAttribute('data-index'), 10);
      if (mainImage) mainImage.src = src;
      setActiveThumb(index);
    });
  });

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      const newIndex = (currentIndex - 1 + thumbBtns.length) % thumbBtns.length;
      const btn      = thumbBtns[newIndex];
      if (mainImage && btn) mainImage.src = btn.getAttribute('data-src');
      setActiveThumb(newIndex);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const newIndex = (currentIndex + 1) % thumbBtns.length;
      const btn      = thumbBtns[newIndex];
      if (mainImage && btn) mainImage.src = btn.getAttribute('data-src');
      setActiveThumb(newIndex);
    });
  }

  // ── Mobile menu toggle ─────────────────────────────────────────────────────
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', !isExpanded);
      mobileMenu.classList.toggle('hidden');
      mobileMenu.classList.toggle('flex');
    });
  }

  // Variant selector sync (Product Page)
  const variantButtons = document.querySelectorAll('[data-option][data-value]');
  const formVariantInput = document.querySelector('input[name="id"]');
  const variantsJson = document.getElementById('product-variants-json');

  if (variantButtons.length > 0 && formVariantInput && variantsJson) {
    let variants = [];
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      console.error('Could not parse variants JSON');
    }

    const selectedOptions = {};

    // Helper: apply deselected style
    function deselect(btn) {
      if (btn.classList.contains('swatch-btn')) {
        btn.style.outline       = 'none';
        btn.style.outlineOffset = '0';
        btn.style.border        = '2px solid transparent';
      } else {
        btn.style.backgroundColor = 'transparent';
        btn.style.color           = '#1c1b1f';
        btn.style.border          = '1px solid #cac4d0';
        btn.style.fontWeight      = '500';
      }
    }

    // Helper: apply selected style
    function selectBtn(btn) {
      if (btn.classList.contains('swatch-btn')) {
        btn.style.outline       = '2px solid #5a3e2b';
        btn.style.outlineOffset = '3px';
        btn.style.border        = '2px solid transparent';
      } else {
        btn.style.backgroundColor = '#5a3e2b';
        btn.style.color           = '#fff';
        btn.style.border          = '1px solid #5a3e2b';
        btn.style.fontWeight      = '600';
      }
    }

    variantButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;

        const optionPos = btn.getAttribute('data-option');
        const value     = btn.getAttribute('data-value');

        // Deselect all siblings in same option group
        btn.parentElement.querySelectorAll('[data-option]').forEach(s => {
          if (!s.disabled) deselect(s);
        });

        // Select the clicked button
        selectBtn(btn);

        selectedOptions[`option${optionPos}`] = value;

        // Find the matching variant
        const matchedVariant = variants.find(v => {
          let match = true;
          if (selectedOptions.option1 && v.option1 !== selectedOptions.option1) match = false;
          if (selectedOptions.option2 && v.option2 !== selectedOptions.option2) match = false;
          if (selectedOptions.option3 && v.option3 !== selectedOptions.option3) match = false;
          return match;
        });

        if (matchedVariant) {
          formVariantInput.value = matchedVariant.id;
          const newUrl = new URL(window.location.href);
          newUrl.searchParams.set('variant', matchedVariant.id);
          window.history.replaceState({}, '', newUrl);

          // Swap main image if variant has one
          if (matchedVariant.featured_image) {
            const mainImage = document.getElementById('main-product-image');
            if (mainImage) mainImage.src = matchedVariant.featured_image.src;
          }
        }
      });
    });
  }

  // ── Cart Drawer Logic ──────────────────────────────────────────────────────
  window.CartDrawer = {
    showLoader: function() {
      const loader = document.getElementById('CartDrawerLoader');
      if (loader) loader.style.display = 'flex';
    },
    hideLoader: function() {
      const loader = document.getElementById('CartDrawerLoader');
      if (loader) loader.style.display = 'none';
    },
    open: function() {
      const container = document.getElementById('CartDrawer');
      const panel     = document.getElementById('CartDrawerPanel');
      if (!container || !panel) { console.warn('CartDrawer: elements not found'); return; }

      container.style.display = 'block';
      document.body.style.overflow = 'hidden';
      // Trigger transition on next frame
      requestAnimationFrame(() => {
        panel.style.transform = 'translateX(0)';
      });
    },
    close: function() {
      const container = document.getElementById('CartDrawer');
      const panel     = document.getElementById('CartDrawerPanel');
      if (!container || !panel) return;

      panel.style.transform = 'translateX(100%)';
      document.body.style.overflow = '';
      // Hide after transition ends
      setTimeout(() => { container.style.display = 'none'; }, 310);
    },
    refresh: function() {
      const container = document.getElementById('CartDrawer');
      const wasOpen = container && container.style.display === 'block';

      return fetch(window.location.pathname, { headers: { 'Cache-Control': 'no-cache' } })
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newWrapper = doc.getElementById('cart-drawer-wrapper');

          if (newWrapper) {
            document.getElementById('cart-drawer-wrapper').innerHTML = newWrapper.innerHTML;

            if (wasOpen) {
              // Re-open without animation
              const newContainer = document.getElementById('CartDrawer');
              const newPanel     = document.getElementById('CartDrawerPanel');
              if (newContainer) newContainer.style.display = 'block';
              if (newPanel)     newPanel.style.transform = 'translateX(0)';
            }

            this.attachListeners();
            this.hideLoader();

            fetch('/cart.js').then(r => r.json()).then(cart => {
              document.querySelectorAll('.cart-count-badge').forEach(badge => {
                badge.textContent = cart.item_count;
                if (cart.item_count > 0) badge.classList.remove('hidden');
                else badge.classList.add('hidden');
              });
            });
          }
        });
    },
    updateQuantity: function(line, quantity, requested) {
      this.showLoader();

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new URLSearchParams({ line: line, quantity: quantity })
      })
      .then(r => r.json().then(data => {
        if (!r.ok) {
          const msg = data.description || data.message || 'Could not update cart.';
          this.hideLoader();
          this.showError(msg);
          return null;
        }
        return data;
      }))
      .then(cart => {
        if (!cart) return;
        this.refresh().then(() => {
          if (quantity > 0) {
            const cartItem = cart.items[line - 1];
            if (cartItem && cartItem.quantity < requested) {
              this.showError('Only ' + cartItem.quantity + ' unit(s) of "' + cartItem.title + '" are in stock.');
            }
          }
        });
      })
      .catch(err => {
        console.error(err);
        this.hideLoader();
        this.showError('Something went wrong.');
      });
    },
    showError: function(msg) {
      const el = document.getElementById('cart-drawer-errors');
      if (el) {
        el.textContent = msg;
        el.style.display = 'block';
        el.classList.remove('hidden');
        setTimeout(() => { el.style.display = 'none'; }, 6000);
      }
    },
    attachListeners: function() {
      // Close button(s) inside the drawer
      document.querySelectorAll('.cart-drawer-close').forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      });

      // Overlay click closes drawer
      const overlay = document.getElementById('CartDrawerOverlay');
      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }

      // Quantity buttons
      document.querySelectorAll('.drawer-qty-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const line   = parseInt(btn.getAttribute('data-line'));
          const action = btn.getAttribute('data-action');
          const span   = btn.parentElement.querySelector('.drawer-qty-display');
          const currentQty = parseInt(span.textContent);
          const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
          this.updateQuantity(line, newQty, newQty);
        });
      });

      // Remove buttons
      document.querySelectorAll('.drawer-remove-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const line = parseInt(btn.getAttribute('data-line'));
          btn.disabled = true;
          btn.style.opacity = '0.4';
          this.updateQuantity(line, 0, 0);
        });
      });
    }
  };

  // Delegated cart drawer trigger — works even if HotReload re-renders the header
  document.body.addEventListener('click', function(e) {
    const trigger = e.target.closest('.js-cart-drawer-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      CartDrawer.open();
    }
  }, true); // capture phase so it fires before HotReload

  // Init listeners on load
  CartDrawer.attachListeners();

  // Quick View Button redirect
  const quickViewBtns = document.querySelectorAll('.quick-view-btn');
  quickViewBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const productUrl = btn.getAttribute('data-product-url');
      if (productUrl) {
        window.location.href = productUrl;
      }
    });
  });
});
